import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { CheckCircle, Calendar, Clock, User, Scissors, Phone, Home, CalendarPlus } from 'lucide-react';
import './ConfirmationPage.css';

export default function ConfirmationPage() {
  const { state } = useLocation();
  const booking = state?.booking;

  if (!booking) {
    return (
      <div className="confirm-page">
        <div className="confirm-container">
          <h2>Reserva não encontrada.</h2>
          <Link to="/" className="btn-primary">Voltar ao Início</Link>
        </div>
      </div>
    );
  }

  const formatDate = (dateStr) => {
    const [y, m, d] = dateStr.split('-');
    const months = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];
    return `${parseInt(d)} de ${months[parseInt(m) - 1]} de ${y}`;
  };

  return (
    <div className="confirm-page">
      <div className="confirm-container">
        <div className="confirm-icon-wrap">
          <div className="confirm-circle">
            <CheckCircle size={48} strokeWidth={1.5} />
          </div>
          <div className="confirm-sparkles">✨</div>
        </div>

        <h1 className="confirm-title">Reserva Confirmada!</h1>
        <p className="confirm-subtitle">
          Sua reserva foi realizada com sucesso. Te aguardamos!
        </p>

        <div className="confirm-card">
          <div className="confirm-card-header">
            <Scissors size={16} strokeWidth={1.5} />
            <span>Detalhes do Agendamento</span>
            <span className="confirm-badge">#{booking.id}</span>
          </div>

          <div className="confirm-row">
            <div className="confirm-icon-label">
              <User size={16} />
              <span>Profissional</span>
            </div>
            <span className="confirm-val">{booking.stylist_name}</span>
          </div>

          <div className="confirm-row">
            <div className="confirm-icon-label">
              <Scissors size={16} />
              <span>Serviço</span>
            </div>
            <span className="confirm-val">{booking.service_name}</span>
          </div>

          <div className="confirm-row">
            <div className="confirm-icon-label">
              <Calendar size={16} />
              <span>Data</span>
            </div>
            <span className="confirm-val">{formatDate(booking.booking_date)}</span>
          </div>

          <div className="confirm-row">
            <div className="confirm-icon-label">
              <Clock size={16} />
              <span>Horário</span>
            </div>
            <span className="confirm-val">{booking.booking_time}</span>
          </div>

          <div className="confirm-row">
            <div className="confirm-icon-label">
              <User size={16} />
              <span>Cliente</span>
            </div>
            <span className="confirm-val">{booking.client_name}</span>
          </div>

          <div className="confirm-row">
            <div className="confirm-icon-label">
              <Phone size={16} />
              <span>Telefone</span>
            </div>
            <span className="confirm-val">{booking.client_phone}</span>
          </div>

          <div className="confirm-divider" />

          <div className="confirm-row confirm-total-row">
            <span className="confirm-total-label">Total</span>
            <span className="confirm-total-val">
              R$ {booking.price?.toFixed(2).replace('.', ',')}
            </span>
          </div>
        </div>

        <div className="confirm-notice">
          <span>💡</span>
          <p>
            Caso precise cancelar ou reagendar, entre em contato pelo WhatsApp com no mínimo
            24 horas de antecedência.
          </p>
        </div>

        <div className="confirm-actions">
          <Link to="/" className="btn-secondary">
            <Home size={16} /> Voltar ao Início
          </Link>
          <Link to="/reservar" className="btn-primary">
            <CalendarPlus size={16} /> Novo Agendamento
          </Link>
        </div>
      </div>
    </div>
  );
}
